import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateWithTimezoneComponent } from './date-with-timezone.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [DateWithTimezoneComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconModule],
  exports: [DateWithTimezoneComponent],
})
export class TimezoneModule {}
